import {useParams, useNavigate} from "react-router-dom";

export default function withParams(Component: any) {
    return (props: any) => <Component {...props} params={useParams()} navigate={useNavigate()} />;
}
